var _excluded = ["children", "label", "position", "offset", "className", "tooltipClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import classNamesMaker from "classnames";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css?raw";
import styles from "./Tooltip.module.css";
export var TOOLTIP_POSITIONS = {
  TOP: "top",
  TOP_START: "top-start",
  TOP_END: "top-end",
  RIGHT: "right",
  RIGHT_START: "right-start",
  RIGHT_END: "right-end",
  BOTTOM: "bottom",
  BOTTOM_START: "bottom-start",
  BOTTOM_END: "bottom-end",
  LEFT: "left",
  LEFT_START: "left-start",
  LEFT_END: "left-end"
};
export var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    label = _ref.label,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "bottom" : _ref$position,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? [0, 12] : _ref$offset,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$tooltipClassName = _ref.tooltipClassName,
    tooltipClassName = _ref$tooltipClassName === void 0 ? "" : _ref$tooltipClassName,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var tooltipClassNames = classNamesMaker(styles["jds-Tooltip"], tooltipClassName);
  return /*#__PURE__*/React.createElement(Tippy, _extends({
    placement: position,
    className: tooltipClassNames,
    content: /*#__PURE__*/React.createElement("span", {
      className: styles["jds-Tooltip__label"]
    }, label),
    offset: offset
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: classNamesMaker(styles["jds-Tooltip__childrenWrapper"], className)
  }, children));
};